var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fiscais-de-contratos"},[_c('v-card',{staticClass:"auth-content",attrs:{"tile":""}},[_c('PageTitle',{attrs:{"main":"TcWeb","icon":"mdi-pencil-box-outline","sub":"Funções Específicas","home":"/"}}),_c('page-cad')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }